import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionServerSelectors, SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { useFormikContext } from '~src/settings/FormikWrapperForStubbing';
import { componentRegistryEntry } from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import { useSelector } from '~src/settings/general-settings/utils';
import { MobileSiteSettingsSubFormikProps } from '~src/settings/mobile-settings/site-settings/MobileSiteSettingsCoordinator';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { SettingsStyles } from '~src/settings/styles/CommonStyles';

import { sectionDescription, sectionHeader, settingSection } from '../styles/MobileSecuritySectionStyle';

export const MOBILE_GENERAL_SETTINGS_SECTION_TEST_ID = 'mobile-general-settings-section';
export const MOBILE_SNAPSHOTS_CHECKBOX_TEST_ID = 'allow-mobile-settings-snapshots-checkbox';
export const MOBILE_BIOMETRICS_CHECKBOX_TEST_ID = 'allow-mobile-settings-biometrics-checkbox';

const SHEET_IMAGE_ENABLED_FIELD = 'settings.siteSettingsForSiteAdmin.siteAdminSettings.sheetImageEnabled';
const MOBILE_BIOMETRICS_ENABLED_FIELD = 'settings.siteSettingsForSiteAdmin.siteAdminSettings.mobileBiometricsEnabled';

export function MobileGeneralSettingsSection(_props: MobileSiteSettingsSubFormikProps) {
  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  const isSessionServerAdmin = useSelector(SessionUserSelectors.isSessionServerAdmin);
  const formik = useFormikContext<MobileSiteSettingsSubFormikProps>();

  return (
    <div className={SettingsStyles.settingsGroup} data-tb-test-id={MOBILE_GENERAL_SETTINGS_SECTION_TEST_ID}>
      <div className={sectionHeader}>{Messages.settings_mobile_title_server()}</div>
      <div className={sectionDescription}>{Messages.settings_mobile_description()}</div>

      <div className={SettingsStyles.indent}>
        {FeatureFlags.showMobileBiometricsSetting && (isSessionServerAdmin || ServerSettingsUnauthenticated.isSiteSamlEnabled()) &&
          <>
            <div className={settingSection}>
              <div className={SettingsStyles.settingsGroupName}>{Messages.settings_mobile_title_biometric()}</div>
              <div className={SettingsStyles.settingsGroupDescription}>{Messages.biometricsMobileDetails()}</div>
              <div className={SettingsStyles.checkboxGroup}>
                <FormikCheckbox
                  checked={formik.getFieldProps(MOBILE_BIOMETRICS_ENABLED_FIELD).value}
                  name={MOBILE_BIOMETRICS_ENABLED_FIELD}
                  label={Messages.enableBiometricsMobile()}
                  testId={MOBILE_BIOMETRICS_CHECKBOX_TEST_ID}
                />
              </div>
            </div>
          </>
        }

        <div className={settingSection}>
          <div className={SettingsStyles.settingsGroupName}>{Messages.settings_mobile_title_offline_preview()}</div>
          <div className={SettingsStyles.settingsGroupDescription}>{FeatureFlags.ntbueGlobalEnabled ? Messages.mobileOfflinePreviews() : Messages.mobileSheetImageDetails()}</div>
          <div className={SettingsStyles.checkboxGroup}>
            <FormikCheckbox
              checked={formik.getFieldProps(SHEET_IMAGE_ENABLED_FIELD).value}
              name={SHEET_IMAGE_ENABLED_FIELD}
              label={Messages.createOfflineSnapShots()}
              testId={MOBILE_SNAPSHOTS_CHECKBOX_TEST_ID}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

/* for registering the component in settings registry */
export const MobileGeneralSettingsSectionSpecs = componentRegistryEntry({
  name: 'MobileGeneralSettingsSection',
  component: MobileGeneralSettingsSection
});
